module.exports = __webpack_public_path__ + "img/hometile_xl.f39f217a.png";